/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formvalidation_Phonee1642Inputs */

const en_formvalidation_phonee1642 = /** @type {(inputs: Formvalidation_Phonee1642Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone number must be in international format: +<country code><number> (e.g., +14155552671)`)
};

/**
* | output |
* | --- |
* | "Phone number must be in international format: +<country code><number> (e.g., +14155552671)" |
*
* @param {Formvalidation_Phonee1642Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formvalidation_phonee1642 = /** @type {((inputs?: Formvalidation_Phonee1642Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formvalidation_Phonee1642Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formvalidation_phonee1642(inputs)
});
export { formvalidation_phonee1642 as "formValidation_phoneE164" }